import(/* webpackMode: "eager" */ "/app/app/blog/blog-page.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/blog/blog.scss");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
